import {
  SET_USER_INFO,
  SET_TOKEN,
} from '../actions/types';

const INITIAL_STATE = {
  apiToken: '',
  userInfo: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "rotate":
      return {
        rotating: action.payload
      };
    case "userData":
      return {
        userInfo: action.payload
      }
    case SET_TOKEN:
      return {
        ...state,
        apiToken: action.payload,
      };

    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload,
      };

    default:
      return state;
  }
};